module.exports = __webpack_public_path__ + "img/c01_unithypaspist_Normal_ua.3353ebe0.webp";